import { AccessDenied } from '@/components/ui/access-denied';
import { useAccessControl } from '@/hooks/useAccessControl';
import ApkManagementModule from '@/modules/apk-management';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/apk-management')({
  component: ApkManagementPage,
});

function ApkManagementPage() {
  const { canAccessApkManagement } = useAccessControl();

  if (!canAccessApkManagement) {
    return <AccessDenied />;
  }

  return <ApkManagementModule />;
}
